import axios from "axios";
import Base from "./Base";
import HomePage from "@system/config/home-page";
import documentResponseMaker from "./HomePageContentAPICall/documentResponseMaker";
import Auth from "@system/config/auth";
import { isArray } from "underscore";
import Helper from "src/support/Helper";

class HomePageDocumentContentAPICall extends Base {
    getDocumentListCount = async (search = "") => {
        let orderByDirection = "asc";
        let orderBy = "DocumentType";
        search = search + "*";
        let d = {
            search,
            skip: 0, top: 0,
            orderby: orderBy + " " + orderByDirection
        };
        d.isIncludeCount = true;
        d.isSkipFacets = false;
        let res = {
            data: {}
        };
        await this.axiosCall(HomePage.DOCUMENT_CONTENT_DATA_LIST, d).then(function (response) {
            res.data = response.data.Data
        });
        let result = await new documentResponseMaker(res);
        result = await result.process();
        return result.run().get();
    };
    getDocumentList = async (search = "", page = false, limit = false, orderByDirection = "asc", orderBy = "DocumentType", selectedFilterList = [], dateRangeObject = []) => {
        if (page === false) {
            page = 1;
        }
        if (limit === false) {
            limit = 10;
        }
        let skip = limit * (page - 1);
        if (!skip) {
            skip = 0;
        }
        if (skip < 0) {
            skip = 0;
        }
        let res = {
            data: {}
        };
        search = search + "*";
        let d = {
            search,
            skip, top: limit,
            orderby: orderBy + " " + orderByDirection
        };
        let filter = '';
        if (selectedFilterList.length > 0) {
            let filterObj = {};
            selectedFilterList.map((v) => {
                //filter = filter + " " + v.fieldName + " eq " + "'" + v.filterName + "' or";
                if (filterObj[v.fieldName] === undefined) {
                    filterObj[v.fieldName] = []; // prepare  field wise array
                }
                filterObj[v.fieldName].push(v.filterName);
            });
            if (Object.entries(filterObj).length > 0) {
                Object.entries(filterObj).forEach((k, l) => {
                    k[1].forEach((i, j) => {
                        if (j === 0) {
                            if (filter.length) // append if new key found
                            {
                                filter += ' and ';
                            }
                            filter += 'search.in(' + Object.keys(filterObj)[l] + ',' + "'" + i + `${!k[1][j + 1] ? "'" : ""}`
                        } else {
                            filter += `|${i}${!k[1][j + 1] ? "'" : ""}`
                        }
                    });
                    filter += ",'|')";
                });
            }
            filter = filter + ' and';
        }
        /*        DatePublished ge startdate and DatePublished le enddate ",
        like : " DatePublished ge 2016-01-09T00:00:00Z and DatePublished le 2019-01-31T00:00:00Z
                 DatePublished ge 2019-12-31T18:29:59.999Z and DatePublished le 2019-11-30T18:30:00.000Z

         DatePublished ge 2022-08-31T18:30:00.000Z and DatePublished le 2022-09-30T18:29:59.999Z

         DatePublished ge 2018-12-31T18:30:00.000Z and DatePublished le 2019-01-31T18:29:59.999Z

         DatePublished ge 2019-11-30T18:30:00.000Z and DatePublished le 2019-12-31T18:29:59.999Z
         "*/
        if (isArray(dateRangeObject) && dateRangeObject.length === 2) {
            let dateRangeObject_filter = '';
            if (filter !== '') {
                dateRangeObject_filter = ' ';
            }
            if (dateRangeObject[0] && dateRangeObject[1]) {
                dateRangeObject_filter += 'DatePublished ge ' + dateRangeObject[0] + ' and DatePublished le ' + dateRangeObject[1] + " and";
            }
            if (dateRangeObject_filter) {
                filter += dateRangeObject_filter
            }
        }
        d.isIncludeCount = true;
        d.isSkipFacets = false;
        if (filter !== '') {
            d.filter = filter;
        }
        await this.axiosCall(HomePage.DOCUMENT_CONTENT_DATA_LIST, d).then(function (response) {
            res.data = response.data.Data
        });
        let result = await new documentResponseMaker(res);
        result = await result.process();
        return result.run().get();
    };
    axiosCall = async (url, data = {}) => {
        data = {
            "searchColumns": [
                ""
            ],
            "searchType": "GlobalSearch",
            ...data
        };

        if (data.filter !== undefined) {
            data.filter = data.filter + " sboat eq '" + Auth.getAuthSBoat() + "'";
        }

        if (data.filter === undefined) {
            data.filter = "sboat eq '" + Auth.getAuthSBoat() + "'";
        }

        let config = {
            method: "POST",
            url: Helper.appendTierQuery(url),
            headers: Helper.getCommonHeader('POST', '', 'application/json, text/javascript, *\/*; q=0.01'),
            data: data
        };
        return axios(config);
    };
}

export default HomePageDocumentContentAPICall;